import { FunctionComponent } from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Label } from 'src/shared';
import AvailabilityCell from 'src/pages/Community/ContributorsRow/AvailabilityCell';
import { tableStyles } from '../ProjectContributors/styled';
import { IProjectContributor } from 'src/types/projects';
import { formatContributorTimestamp } from 'src/utils/contributorStatus';
import { UserStatus } from 'src/enums/user';

export interface Props {
    row: IProjectContributor;
}

const ContributorRow: FunctionComponent<Props> = ({ row }: Props) => {
    return (
        <TableRow sx={tableStyles.dataRow}>
            <TableCell
                sx={{
                    ...tableStyles.muiTableCell,
                    ...tableStyles.firstHeadCell,
                    ...tableStyles.dataCellPadding
                }}
            >
                <Label
                    component="span"
                    sxOverrides={{
                        ...tableStyles.baseLabel,
                        ...tableStyles.dataCell
                    }}
                >
                    {row.name}
                </Label>
            </TableCell>
            <TableCell
                sx={{
                    ...tableStyles.muiTableCell,
                    ...tableStyles.dataCellPadding,
                    ...tableStyles.headCellXsPlus,
                    ...tableStyles.statusCell
                }}
            >
                <AvailabilityCell
                    userId={row.id}
                    status={row.status as UserStatus}
                    lastStatusUpdated={row.lastStatusUpdated ?? undefined}
                />
            </TableCell>
            <TableCell
                sx={{
                    ...tableStyles.muiTableCell,
                    ...tableStyles.headCellXl,
                    ...tableStyles.dataCellPadding
                }}
            >
                <Label
                    component="span"
                    sxOverrides={{
                        ...tableStyles.baseLabel,
                        ...tableStyles.dataCell
                    }}
                >
                    {formatContributorTimestamp(row.lastEngagement)}
                </Label>
            </TableCell>
            <TableCell
                sx={{
                    ...tableStyles.muiTableCell,
                    ...tableStyles.headCellMd,
                    ...tableStyles.dataCellPadding
                }}
            >
                <Label
                    component="span"
                    sxOverrides={{
                        ...tableStyles.baseLabel,
                        ...tableStyles.dataCell
                    }}
                >
                    {row.reservedWorks}
                </Label>
            </TableCell>
            <TableCell
                sx={{
                    ...tableStyles.muiTableCell,
                    ...tableStyles.dataCellPadding
                }}
            >
                <Label
                    component="span"
                    sxOverrides={{
                        ...tableStyles.baseLabel,
                        ...tableStyles.dataCell
                    }}
                >
                    {'$' + row.hourlyRate}
                </Label>
            </TableCell>
            <TableCell
                sx={{
                    ...tableStyles.muiTableCell,
                    ...tableStyles.lastHeadCell,
                    ...tableStyles.dataCellPadding
                }}
            >
                <Label
                    component="span"
                    sxOverrides={{
                        ...tableStyles.baseLabel,
                        ...tableStyles.dataCell
                    }}
                >
                    {row.skills.join(', ')}
                </Label>
            </TableCell>
        </TableRow>
    );
};

export default ContributorRow;
